import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import local from '@/utils/local'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    data:{}
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
